import Button from 'components/button-new';
import ImpressionTrackerNew from 'components/impression-tracker/new-impression-tracker';
import { useConfig } from 'config/use-config';
import useRefresh from 'hooks/common/use-refresh';
import { Gtm } from 'tracking';
import Image from 'next/legacy/image';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import InfluencerCollectionSlider from '../components/influencer-colletion-slider';
import bowlImage from './bowl.png';

const TRACKING_ELEMENT = 'Pet Type Selector';

const Landingpage: FC = () => {
  useRefresh();
  const { commonPagePaths } = useConfig();

  return (
    <>
      <InfluencerCollectionSlider className="lg:mb-16" data-test="influencer-collection-slider" />
      <div
        className="bg-primary-main text-other-white flex min-h-[calc(100svh_-_var(--header-height))] flex-col px-4 text-center lg:px-0"
        data-test="pet-type-container"
      >
        <h1
          className="mindset-48 lg:mindset-80 mx-auto mt-12 mb-2 max-w-[568px] whitespace-pre-wrap lg:mt-16"
          data-test="landingpage-title"
        >
          <FormattedMessage id="landingpage:home:home:title" />
        </h1>

        <p
          className="mb-6 text-sm leading-5 lg:mb-8 lg:text-xl lg:leading-7"
          data-test="landingpage-sub-title"
        >
          <FormattedMessage
            id="landingpage:home:home:sub-title"
            values={{
              span: (text) => (
                <span className="font-medium" data-test="landingpage-sub-title-span">
                  {text}
                </span>
              ),
            }}
          />
        </p>

        <ImpressionTrackerNew element={TRACKING_ELEMENT}>
          <div
            className="mb-14 flex justify-center gap-3 lg:mb-20"
            data-test="pet-type-buttons-container"
          >
            <Button
              className="max-w-[272px]"
              href={commonPagePaths.dogsHome}
              onClick={() => {
                Gtm.track.selectElement({ element: ['Pet Type Selector', 'dog'] });
              }}
              layout={'contained'}
              size="large"
              data-test="button-for-dogs"
            >
              <FormattedMessage id="common:for-dogs" />
            </Button>

            <Button
              className="max-w-[272px]"
              href={commonPagePaths.catsHome}
              onClick={() => {
                Gtm.track.selectElement({ element: ['Pet Type Selector', 'cat'] });
              }}
              layout={'contained'}
              size="large"
              data-test="button-for-cats"
            >
              <FormattedMessage id="common:for-cats" />
            </Button>
          </div>
        </ImpressionTrackerNew>

        <div className="mx-auto mt-auto w-full max-w-2xl" data-test="bowl-image-container">
          <Image
            src={bowlImage}
            objectFit="cover"
            layout="responsive"
            quality={100}
            data-test="bowl-image"
          />
        </div>
      </div>
    </>
  );
};

export default Landingpage;
